import iconTicketSvg from './icon_ticket.svg';
import './TicketReward.css';

export type TicketRewardProps = {
  rewardPasses: number;
};

/** Figma icon_ticket + dynamic «+N» text — ticket reward in header. */
export function TicketReward({ rewardPasses }: TicketRewardProps) {
  return (
    <>
      <span className="ticket-reward__badge" aria-hidden>
        +{rewardPasses}
      </span>
      <img
        className="ticket-reward__icon"
        src={iconTicketSvg}
        alt=""
        draggable={false}
        aria-hidden
      />
    </>
  );
}
